<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="organize_name" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.organize_name }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="iie_location_name">{{ $t('iie_location_name') }}</label>
                                <InputText
                                    id="iie_location_name"
                                    type="text"
                                    v-model="location_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="iie_disaster">{{ $t('support_disaster') }}</label>
                                <Dropdown
                                    v-model="disasterSelect"
                                    :options="disasterOptions"
                                    optionLabel="system_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="disasterOptions">
                                        <div v-if="disasterOptions.value">
                                            <div>{{ disasterOptions.value.system_name }}</div>
                                        </div>
                                        <span v-else>
                                            {{ disasterOptions.placeholder }}
                                        </span>
                                    </template>
                                    <template #option="disasterOptions">
                                        <div class="EV_disasterOptions">
                                            {{ disasterOptions.option.system_name }}
                                        </div>
                                    </template>
                                </Dropdown>
                            </div>
                            <!-- <div class="p-field p-col-8 p-lg-3 p-mt-2">
                  <label for="iie_organize">{{ $t("response_agency") }}</label>
                  <InputText
                    id="iie_organize"
                    type="text"
                    v-model="selectedOrganize.name"
                    disabled
                  />
                </div>
                <div class="p-field p-lg-1" style="padding-top: 3.5px ;">
                  <div class="p-formgrid p-grid p-jc-start">
                    <Button
                      @click="showOrganize = true"
                      icon="pi pi-ellipsis-h"
                      class="p-button-secondary p-mt-5 p-mr-2"
                    />
                    <Button
                      @click="selectedOrganize = {}"
                      icon="pi pi-times"
                      class="p-button-danger p-mt-5"
                    />
                  </div>
                </div> -->

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="provinceOptions">{{ $t('province') }}</label>
                                <Dropdown
                                    v-model="selectedProvince"
                                    :options="provinceOptions"
                                    optionLabel="province_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="provinceOptions">
                                        <div v-if="provinceOptions.value">
                                            <div>{{ provinceOptions.value.province_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="provinceOptions">
                                        <div>{{ provinceOptions.option.province_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="amphurOptions">{{ $t('amphur') }}</label>
                                <Dropdown
                                    :disabled="isDisabledAmphur == 1"
                                    v-model="selectedAmphur"
                                    :options="amphurOptions"
                                    optionLabel="amphur_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="amphurOptions">
                                        <div v-if="amphurOptions.value">
                                            <div>{{ amphurOptions.value.amphur_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="amphurOptions">
                                        <div>{{ amphurOptions.option.amphur_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>

                            <div class="p-field p-col-12 p-lg-4 p-mt-2">
                                <label for="tambonOptions">{{ $t('tambon') }}</label>
                                <Dropdown
                                    :disabled="isDisabledTambon == 1"
                                    v-model="selectedTambon"
                                    :options="tambonOptions"
                                    optionLabel="tambon_name"
                                    :filter="true"
                                    :placeholder="$t('placeholderSelectBox')"
                                    :showClear="true"
                                    :clearFilterDropdown="dropdownClearFilerValue"
                                >
                                    <template #value="tambonOptions">
                                        <div v-if="tambonOptions.value">
                                            <div>{{ tambonOptions.value.tambon_name }}</div>
                                        </div>
                                    </template>
                                    <template #option="tambonOptions">
                                        <div>{{ tambonOptions.option.tambon_name }}</div>
                                    </template>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-field p-col">
                    <div class="p-formgrid p-grid p-jc-end p-mt-5">
                        <!-- Doe โหลด โทรศัพท์ -->
                        <Button
                            v-if="window.width <= 430"
                            @click="MobileClearSearchField()"
                            :label="$t('clearBtn')"
                            class="p-button-clear p-ml-3 p-mr-3"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                        <Button
                            v-else
                            @click="clearSearchField()"
                            :label="$t('clearBtn')"
                            class="p-button-clear p-ml-3 p-mr-3"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                        <!-- Doe โหลด โทรศัพท์ -->
                        <Button
                            @click="searchEvacuation()"
                            :label="$t('searchBtn')"
                            class="p-button-info"
                            ref="TextBox_4_search"
                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <!-- <div class="p-field p-col-12 p-mt-2" id="text_Footer">
              {{ text_Footer }}
            </div> -->
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="evacuation_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? evacuation_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :loading="loading"
                :sortOrder="1"
                sortField="index"
                dataKey="evacuation_id"
                ref="dt"
                :exportFilename="`ข้อมูลพื้นที่อพยพ-${date}`"
                :rowHover="true"
                :selection.sync="selectedEvacuation"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="evacuationModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button
                                @click="exportCSV()"
                                :label="$t('exportBtn')"
                                style="background-color: green; width: 100%; border: 1px solid green"
                            />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedEvacuation && selectedEvacuation.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left" >
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedEvacuation.length === evacuation_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedEvacuation.some((item) => item.evacuation_id === slotProps.data.evacuation_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div style="text-align: center" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_img == true">
                    <Column field="" :header="'รูปภาพ'" :headerStyle="tableColSticky('20rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_img == true">
                                <div v-if="dataTable.data.image !== '' && dataTable.data.image !== null && columns_img == true">
                                    <img
                                        :src="pickRecordImage(dataTable.data, 'image')"
                                        @click="showImage(pickRecordImageRaw(dataTable.data, 'image'))"
                                        alt=""
                                        style="height: 112px; max-width: 240px"
                                    />
                                </div>

                                <div v-else>-</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_name == true">
                    <Column
                        field="evacuation_name"
                        :header="$t('iie_location_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_name == true">
                                {{ dataTable.data.evacuation_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_disaster == true">
                    <Column
                        field="disaster"
                        :header="$t('support_disaster')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <!-- <div v-if="dataTable.data.disaster_id == '[]'">-</div>
              <div v-else>
                <div
                  v-for="disaster in JSON.parse(dataTable.data.disaster_id)"
                  :key="disaster.disaster_id"
                >
                  {{ disaster.system_name }}
                </div>
              </div> -->
                            <div v-if="columns_disaster == true">
                                <div v-if="dataTable.data.disaster_id == '[]'">-</div>
                                <div v-else>
                                    {{ dataTable.data.disaster }}
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_organize_name == true">
                    <Column
                        field="organize_name"
                        :header="$t('response_agency')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_organize_name == true">
                                {{ dataTable.data.organize_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_location == true">
                    <Column
                        field="evacuation_location"
                        :header="$t('location')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_location == true">
                                <div v-if="dataTable.data.evacuation_location == ''">-</div>
                                <div v-else>{{ dataTable.data.evacuation_location }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_entry == true">
                    <Column
                        field="evacuation_entry"
                        :header="$t('iie_entry')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_entry == true">
                                <div v-if="dataTable.data.evacuation_entry == null || dataTable.data.evacuation_entry == ''">-</div>
                                <div v-else>{{ dataTable.data.evacuation_entry }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_exit == true">
                    <Column
                        field="evacuation_exit"
                        :header="$t('iie_exit')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_exit == true">
                                <div v-if="dataTable.data.evacuation_exit == '' || dataTable.data.evacuation_exit == null">-</div>
                                <div v-else>{{ dataTable.data.evacuation_exit }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_area == true">
                    <Column
                        field="evacuation_area"
                        :header="$t('iie_area')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_area == true">
                                <div v-if="dataTable.data.evacuation_area == '' || dataTable.data.evacuation_area == null">-</div>
                                <div v-else>{{ dataTable.data.evacuation_area }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_capacity == true">
                    <Column
                        field="evacuation_capacity"
                        :header="$t('iie_capacity')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_capacity == true">
                                <div v-if="dataTable.data.evacuation_capacity == '' || dataTable.data.evacuation_capacity == null">-</div>
                                <div v-else>{{ dataTable.data.evacuation_capacity }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_latitude == true">
                    <Column
                        field="evacuation_lat"
                        :header="$t('latitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_latitude == true">
                                <div v-if="dataTable.data.evacuation_lat == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.evacuation_lat).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_longitude == true">
                    <Column
                        field="evacuation_lon"
                        :header="$t('longitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_longitude == true">
                                <div v-if="dataTable.data.evacuation_lon == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.evacuation_lon).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_contact_name == true">
                    <Column
                        field="evacuation_contact_name"
                        :header="$t('contact_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_contact_name == true">
                                <div v-if="dataTable.data.evacuation_contact_name == ''">-</div>
                                <div v-else>{{ dataTable.data.evacuation_contact_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_evacuation_contact_phone == true">
                    <!-- <Column  
            field="evacuation_contact_phone"
            :header="$t('contact_phone')"
            :sortable="true"
            headerStyle="width: 15rem"
          >
            <template #body="dataTable">
              <div v-if="dataTable.data.evacuation_contact_phone == ''">-</div>
              <div v-else>{{ dataTable.data.evacuation_contact_phone }}</div>
            </template>
          </Column> -->
                    <Column
                        field="text_tel_detail"
                        :header="$t('contact_phone')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_evacuation_contact_phone == true">
                                <span v-html="dataTable.data.text_tel_detailHTML"></span>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_evacuation_contact_phone ||
                        columns_index ||
                        columns_img ||
                        columns_evacuation_name ||
                        columns_disaster ||
                        columns_organize_name ||
                        columns_evacuation_location ||
                        columns_evacuation_entry ||
                        columns_evacuation_exit ||
                        columns_evacuation_area ||
                        columns_evacuation_capacity ||
                        columns_evacuation_latitude ||
                        columns_evacuation_longitude ||
                        columns_evacuation_contact_name ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <!-- <div class="p-formgrid p-grid" v-if="checkNotAdminPermission(dataTable.data.user_organize)"> -->
                            <!-- checkNotAdminPermission เอาไว้เช็คว่าต้องเป็น User ตัวเองเท่านั้นถึงแก้ได้ ในกรณีที่ไม่ใช่ Admin System  -->
                            <!-- แก้ใหม่ให้เปิดให้แก้ไขได้ -->
                            <div class="p-formgrid col_manege" style="text-align: center">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            evacuationModal = true;
                                            editData(dataTable.data.evacuation_id);
                                            temp = dataTable.data.evacuation_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.evacuation_id;
                                            deleteTable = '';
                                            alertDisplay(temp, deleteTable);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="evacuationModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :header="header"
            :closable="loadingCreate ? false : true"
            id="evacuation_manage"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('iie_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="iie_location_name">{{ $t('iie_location_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iie_location_name"
                                type="text"
                                v-model="iie_location_name"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_iie_location_name && !iie_location_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_iie_location_name && !iie_location_name">{{
                                $t('iie_location_name_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-col-8 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="iie_selectedOrganize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                            <InputText
                                id="iie_selectedOrganize"
                                type="text"
                                v-model="iie_selectedOrganize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_iie_organize && !iie_selectedOrganize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_iie_organize && !iie_selectedOrganize.name">{{ $t('iie_organize_validate') }}</small>
                        </div>
                        <div class="p-field p-lg-2">
                            <div>
                                <Button
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                />
                                <Button
                                    @click="iie_selectedOrganize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-8">
                            <label for="iie_location_detail">{{ $t('location') }}</label>
                            <InputText
                                id="iie_location_detail"
                                type="text"
                                v-model="iie_location_detail"
                                required="true"
                                ref="TextBox_4"
                                @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_7', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2 p-mt-5">
                            <span hidden>{{ url }}</span>
                            <div class="p-grid">
                                <div class="p-col-8 p-lg-8">
                                    <Button
                                        @click="onFileChange"
                                        style="margin-top: 3px"
                                        class="p-button-success"
                                        icon="pi pi-plus"
                                        label="เลือกไฟล์ภาพ"
                                        ref="TextBox_5"
                                        @keyup.left="moveFocus($event, 'TextBox_4', 'Input')"
                                        @keyup.right="moveFocus($event, 'TextBox_6', 'Button')"
                                        @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                    >
                                    </Button>
                                    <input
                                        style="visibility: hidden; display: none; text-overflow: ellipsis"
                                        type="file"
                                        id="organize_uploadImageFile"
                                        @change="onFileChange"
                                        class="inputzone"
                                        accept="image/*"
                                    />
                                </div>
                                <div class="p-col-4 p-lg-4">
                                    <Button
                                        @click="clearImage()"
                                        icon="pi pi-times"
                                        class="p-button-danger"
                                        style="width: auto; margin-top: -3px"
                                        :label="$t('clearImage')"
                                        ref="TextBox_6"
                                        @keyup.left="moveFocus($event, 'TextBox_5', 'Button')"
                                        @keyup.right="moveFocus($event, 'TextBox_7', 'Input')"
                                        @keyup.up="moveFocus($event, 'TextBox_3', 'Button')"
                                        @keyup.down="moveFocus($event, 'TextBox_8', 'Input')"
                                    />
                                </div>
                            </div>

                            <div id="preview">
                                <img v-if="resolveImageSrc(url)" :src="resolveImageSrc(url)" />
                            </div>
                            <div id="io_image" ref="io_image" hidden></div>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col">
                            <label for="provinceOptions">{{ $t('province') }}</label>
                            <Dropdown
                                v-model="iie_selectedProvince"
                                @input="inputMap_PAT_latlon"
                                :options="provinceOptions"
                                @change="someHandler('ch-province')"
                                optionLabel="province_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="provinceOptions">
                                    <div v-if="provinceOptions.value">
                                        <div>{{ provinceOptions.value.province_name }}</div>
                                    </div>
                                </template>
                                <template #option="provinceOptions">
                                    <div>{{ provinceOptions.option.province_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col">
                            <label for="amphurOptions">{{ $t('amphur') }}</label>
                            <Dropdown
                                :disabled="iie_isDisabledAmphur == 1"
                                v-model="iie_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col">
                            <label for="tambonOptions">{{ $t('tambon') }}</label>
                            <Dropdown
                                :disabled="iie_isDisabledTambon == 1"
                                v-model="iie_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" จบ-->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="iie_access_main">{{ $t('iie_access_main') }}</label>
                            <InputText
                                id="iie_access_main"
                                type="text"
                                v-model="iie_access_main"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iie_access_tempolary">{{ $t('iie_access_tempolary') }}</label>
                            <InputText
                                id="iie_access_tempolary"
                                type="text"
                                v-model="iie_access_tempolary"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="iie_entry">{{ $t('iie_entry') }}</label>
                            <InputText
                                id="iie_entry"
                                type="text"
                                v-model="iie_entry"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iie_exit">{{ $t('iie_exit') }}</label>
                            <InputText
                                id="iie_exit"
                                type="text"
                                v-model="iie_exit"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="iie_area">{{ $t('iie_area') }}</label>
                            <InputText
                                id="iie_area"
                                type="text"
                                v-model="iie_area"
                                ref="TextBox_7"
                                @keyup.left="moveFocus($event, 'TextBox_6', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_4', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_9', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iie_capacity">{{ $t('iie_capacity') }}</label>
                            <InputText
                                id="iie_capacity"
                                type="text"
                                v-model="iie_capacity"
                                ref="TextBox_8"
                                @keyup.left="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_5', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_10', 'Input')"
                            />
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="iie_contact_name">{{ $t('contact_name') }}</label>
                            <InputText
                                id="iie_contact_name"
                                type="text"
                                v-model="iie_contact_name"
                                ref="TextBox_9"
                                @keyup.left="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_7', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_11', 'Input')"
                            />
                        </div>

                        <!-- <div class="p-field p-col-12  p-lg-6">
                <label for="iie_contact_phone">{{ $t("contact_phone") }}</label>
                <InputText
                  id="iie_contact_phone"
                  type="text"
                  v-model="iie_contact_phone"
                  @input="acceptNumberPhone"
                  autofocus
                />
              </div> -->

                        <!-- <div class="p-field p-col-12  p-lg-6">
                <label for="iie_contact_phone">{{ $t("contact_phone") }}</label>
                <InputText
                  id="iie_contact_phone"
                  type="text"
                  v-model="iie_contact_phone"
                  
                  autofocus
                />
              </div> -->

                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="contact_phone">เบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ)</label>
                            <InputText
                                id="contact_phone"
                                type="text"
                                v-model="contact_phone"
                                @input="acceptNumberPhone"
                                :class="{
                                    'p-invalid': error_contact_phone && contact_phone.length !== 12
                                }"
                                ref="TextBox_10"
                                @keyup.left="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_8', 'Input')"
                                @keyup.down="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_14', 'Input')
                                "
                            />
                            <small class="p-invalid" v-if="error_contact_phone && contact_phone.length !== 12"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (โทรศัพท์มือถือ) 10 หลัก</small
                            >
                        </div>
                    </div>

                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem">
                            <label for="contact_phone_office">เบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)</label>
                            <InputText
                                id="contact_phone_office"
                                type="text"
                                v-model="contact_phone_office"
                                @input="acceptNumberPhone2"
                                :class="{
                                    'p-invalid': error_contact_phone_office && contact_phone_office.length !== 11
                                }"
                                ref="TextBox_11"
                                @keyup.left="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.right="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_13', 'Input')
                                "
                                @keyup.up="moveFocus($event, 'TextBox_9', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_13', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_contact_phone_office && contact_phone_office.length !== 11"
                                >กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน) 9 หลัก</small
                            >
                        </div>

                        <div
                            class="p-field p-col-12 p-lg-6"
                            style="margin-bottom: 0.8rem"
                            v-if="contact_phone_office && contact_phone_office !== '-'"
                        >
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>

                        <div class="p-field p-col-12 p-lg-6" style="margin-bottom: 0.8rem" v-else>
                            <label for="iev_contact_phone">ext. (ต่อเบอร์ภายใน)</label>
                            <InputText
                                disabled
                                id="contact_phone_office_ext"
                                type="text"
                                v-model="contact_phone_office_ext"
                                @input="acceptNumberPhone3"
                                placeholder="กรุณาระบุเบอร์โทรศัพท์ผู้ติดต่อ (สำนักงาน)"
                                ref="TextBox_12"
                                @keyup.left="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_10', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_14', 'Input')"
                            />
                        </div>
                    </div>
                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="iie_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="iie_lat"
                                type="text"
                                v-model="iie_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_13"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_11', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="iie_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="iie_lon"
                                type="text"
                                v-model="iie_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_10', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->
                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(iie_lat, iie_lon);
                                    sendM_PAT(iie_selectedTambon, iie_selectedAmphur, iie_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_10', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- <small class="p-invalid" style="margin-right: .5rem;"
                  v-if="error_latlon_country">กรุณาระบุข้อมูล ละติจูดและลองจิจูด ที่อยู่ในประเทศไทย</small> -->

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->

                    <div class="p-formgrid p-grid p-mt-3 p-mb-3">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="iie_remark">{{ $t('remark') }}<span class="required-input"> </span></label>
                            <InputText
                                id="iie_remark"
                                type="text"
                                v-model="iie_remark"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <label for="disasterOptions">{{ $t('disaster_type') }}</label>
                    <div class="p-formgrid p-grid p-mt-1">
                        <div class="p-field p-col-12 p-lg-8 p-mt-2">
                            <MultiSelect
                                v-model="iie_selectedDisaster"
                                :options="disasterOptions"
                                optionLabel="system_name"
                                :placeholder="$t('placeholderSelectBox')"
                                :filter="true"
                                class="multiselect-custom"
                                :clearFilterMultiSelect="multiSelectClearFilerValue"
                            >
                                <template #value="slotProps">
                                    <div class="item item-value" v-for="option of slotProps.value" :key="option.system_id">
                                        <div>{{ option.system_name }}</div>
                                    </div>
                                    <template v-if="!slotProps.value || slotProps.value.length === 0">
                                        {{ $t('placeholderSelectBox') }}
                                    </template>
                                </template>
                                <template #option="slotProps">
                                    <div class="item">
                                        <div class="EV_disasterOptions">
                                            {{ slotProps.option.system_name }}
                                        </div>
                                    </div>
                                </template>
                            </MultiSelect>
                        </div>
                    </div>
                    <div class="p-formgrid p-grid p-col-12 p-lg-12 p-mt-1">
                        <div class="p-field p-col-12 p-lg-12 p-mt-2">
                            <DataTable
                                :value="disaster_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="10"
                                dataKey="id"
                                :rowHover="true"
                                selectionMode="single"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[10, 20, 50]"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="system_name" :header="$t('support_disaster')" :sortable="true" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        {{ dataTable.data.system_name }}
                                        <!-- {{ dataTable.data }} -->
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        disasterTable = dataTable.data;
                                                        deleteTable = 'disaster';
                                                        alertDisplay(disasterTable, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_17"
                    @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_17"
                    @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_18"
                    @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- <map-area @selectMap="selectMap_passValue" :latlon="this.latlon"  ></map-area> -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" autofocus />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../OrganizeTableForm.vue';
import organizeTable from '../../Report/OrganizeMultiSelectTable.vue';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import { font } from "../../../../public/assets/font/Sarabun-Regular-normal";
// Doe : PDF 2/3 จบ
import moment from 'moment';
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-evacuation',
    components: {
        organizeTable,
        organizeForm,
        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/6
            filter: '',
            dropdownClearFilerValue: 0,
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            evacuation_Table: [],
            loading: false,
            provinceOptions: [],
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            filters: {},
            temp: null,
            disasterTable: null,
            showOrganize: false,
            showOrganize_Form: false,
            selectedEvacuation: [],
            selectedOrganize: {},
            location_name: '',
            displayConfirmation: false,
            deleteTable: '',
            displayMap: false,

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,

            header: this.$i18n.t('iie_modal_title_add'),
            selectedData: '',

            evacuationModal: false,
            iie_location_name: '',
            iie_location_detail: '',
            iie_selectedOrganize: {},
            iie_selectedDisaster: null,
            iie_selectedProvince: null,
            iie_selectedAmphur: null,
            iie_selectedTambon: null,
            iie_isDisabledAmphur: 1,
            iie_isDisabledTambon: 1,
            iie_access_main: '',
            iie_access_tempolary: '',
            iie_entry: '',
            iie_exit: '',
            iie_area: '',
            iie_capacity: '',
            iie_contact_name: '',
            iie_contact_phone: '',
            iie_lat: null,
            iie_lon: null,
            iie_remark: '',

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            error_iie_selectedProvince: false,
            error_iie_selectedAmphur: false,
            error_iie_selectedTambon: false,
            error_iie_selectedOrganize: false,
            error_iie_location_name: false,
            error_iie_organize: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            date_create_form: '',
            date_update_form: '',
            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            selectedOrganizeData: [],
            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อพื้นที่อพยพ',
                    textShow: ''
                },
                {
                    DataName: 'สาธารณภัยที่รองรับ',
                    textShow: ''
                },
                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลพื้นที่อพยพ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 60,
            PDF_FontHeaderVer: 10,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },

                organize_name: { cellWidth: 50 },
                disaster: { cellWidth: 45 },
                evacuation_lat: { cellWidth: 40 },
                evacuation_lon: { cellWidth: 40 },
                text_tel_detail: { cellWidth: 65 },
                date_create_ddmmyy: { cellWidth: 45 },
                date_update_ddmmyy: { cellWidth: 45 },
                evacuation_entry: { cellWidth: 40 },
                evacuation_exit: { cellWidth: 40 },
                evacuation_area: { cellWidth: 40 },
                evacuation_capacity: { cellWidth: 40 },
                evacuation_location: { cellWidth: 43 }
            },

            PDF_minCellWidthHor: 80,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 11,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 },
                // evacuation_name: { cellWidth: 80 },
                organize_name: { cellWidth: 58 },
                disaster: { cellWidth: 50 },
                text_tel_detail: { cellWidth: 90 },
                evacuation_lat: { cellWidth: 55 },
                evacuation_lon: { cellWidth: 55 },
                evacuation_location: { cellWidth: 50 },
                date_create_ddmmyy: { cellWidth: 70 },
                date_update_ddmmyy: { cellWidth: 70 },
                evacuation_entry: { cellWidth: 40 },
                evacuation_exit: { cellWidth: 40 },
                evacuation_area: { cellWidth: 40 },
                evacuation_capacity: { cellWidth: 40 },
                evacuation_contact_name: { cellWidth: 50 },
                evacuation_name: { cellWidth: 70 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'รูปภาพ', dataKey: 'image' },
                { title: 'ชื่อพื้นที่อพยพ', dataKey: 'evacuation_name' },
                { title: 'สาธารณภัยที่รองรับ', dataKey: 'disaster' },
                { title: 'หน่วยงานที่รับผิดชอบ', dataKey: 'organize_name' },
                { title: 'ที่ตั้ง', dataKey: 'evacuation_location' },
                { title: 'ทางเข้า', dataKey: 'evacuation_entry' },
                { title: 'ทางออก', dataKey: 'evacuation_exit' },
                { title: 'ขนาดพื้นที่ (ไร่)', dataKey: 'evacuation_area' },
                { title: 'ความจุ (คน)', dataKey: 'evacuation_capacity' },
                { title: 'ละติจูด', dataKey: 'evacuation_lat' },
                { title: 'ลองจิจูด', dataKey: 'evacuation_lon' },
                { title: 'ชื่อผู้ติดต่อ', dataKey: 'evacuation_contact_name' },
                // {title: "เบอร์โทรศัพท์ผู้ติดต่อ", dataKey: "evacuation_contact_phone"}
                { title: 'เบอร์โทรศัพท์ผู้ติดต่อ', dataKey: 'text_tel_detail' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_evacuation_name: true,
            columns_disaster: true,
            columns_organize_name: true,
            columns_evacuation_location: true,
            columns_evacuation_entry: true,
            columns_evacuation_exit: true,
            columns_evacuation_area: true,
            columns_evacuation_capacity: true,

            columns_evacuation_latitude: true,

            columns_evacuation_longitude: true,

            columns_evacuation_contact_name: true,
            columns_evacuation_contact_phone: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            GetData_ColumnsSearch: [],

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ
            url: null,
            imgTable: null,
            displayBasic2: false,
            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'PDF',
                            detail: 'แนวตั้ง',
                            life: 3000
                        });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'PDF',
                            detail: 'แนวนอน',
                            life: 3000
                        });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index'];
                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async evacuationModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.iie_location_name != '' &&
                    this.iie_selectedOrganize.name != undefined
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.evacuationModal = false;

                            this.tempFor_displayConfirmationCloseModal = '';
                            this.iie_location_name = '';
                            this.iie_selectedOrganize = {};
                            this.iie_location_detail = '';
                            this.iie_selectedProvince = null;
                            this.iie_access_main = '';
                            this.iie_access_tempolary = '';
                            this.iie_entry = '';
                            this.iie_exit = '';
                            this.iie_area = '';
                            this.iie_capacity = '';
                            this.iie_contact_name = '';
                            this.iie_contact_phone = '';
                            this.iie_lat = '';
                            this.iie_lon = '';
                            this.iie_remark = '';
                            this.iie_selectedDisaster = null;
                            this.error_iie_organize = false;
                            this.error_iie_location_name = false;
                            this.disaster_table = [];
                            this.selectedProvince = null;

                            this.contact_phone = '';
                            this.contact_phone_office = '';
                            this.contact_phone_office_ext = '';

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            this.url = null;
                            // document.getElementById("organize_uploadImageFile").value = "";

                            this.date_create_form = '';
                            this.date_update_form = '';
                        } else {
                            this.evacuationModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterOptions = response.data.data),
                                this.disasterOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.iie_selectedOrganize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-province'
                        }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterOptions = response.data.data;
                    });
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.evacuationModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async iie_selectedProvince(val) {
            if (val != null) {
                this.iie_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.iie_selectedProvince.province_id
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
                // this.inputMap_PAT_latlon()
            } else {
                this.iie_isDisabledAmphur = 1;
                this.iie_selectedAmphur = null;
                // this.inputMap_PAT_latlon()
            }
        },

        async iie_selectedAmphur(val) {
            if (val != null) {
                this.iie_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.iie_selectedAmphur.amphur_id
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
                // this.inputMap_PAT_latlon()
            } else {
                this.iie_isDisabledTambon = 1;
                this.iie_selectedTambon = null;
                // this.inputMap_PAT_latlon()
            }
        },

        iie_selectedDisaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.location_id != 'null') {
                    this.iie_selectedProvince = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.iie_selectedAmphur = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.iie_selectedTambon = {
                        tambon_id: val.tambon_id,
                        tambon_name: val.tambon_name
                    };
                } else {
                    this.iie_selectedProvince = null;
                }
            }
        },
        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            // console.log(val)
            if (val.length == 0) {
                this.evacuation_Table = [];
            } else {
                this.evacuation_Table = this.cloneTable;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });
    },

    created() {
        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        for (let index = 0; index < this.columnsSelector.length; index++) {
            this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        }
        // Doe PDF เลือกได้  4/5  จบ
        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedEvacuation.map((item) => ({
                    evacuation_id: item.evacuation_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/evacuation?user=${userId}`, {
                    body: {
                        topic: 'edit-evacuation_date_multiple',
                        selectedEvacuation: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.manInfoModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลพื้นที่อพยพจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchEvacuation();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedEvacuation = [...this.evacuation_Table];
            } else {
                this.selectedEvacuation = [];
            }
            this.$emit('selectedEvacuation', this.selectedEvacuation);
            // console.log('selectedEvacuation', this.selectedEvacuation);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedEvacuation.some((item) => item.evacuation_id === row.evacuation_id)) {
                    this.selectedEvacuation.push(row);
                }
            } else {
                this.selectedEvacuation = this.selectedEvacuation.filter((item) => item.evacuation_id !== row.evacuation_id);
            }
            this.$emit('selectedEvacuation', this.selectedEvacuation);
            // console.log('selectedEvacuation', this.selectedEvacuation);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchEvacuation();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_15') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18')
                ) {
                    this.saveData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.evacuation_Table !== []) {
                    this.evacuation_Table = this.cloneTable.filter((item) => {
                        return (
                            (this.columns_evacuation_name ? item.evacuation_name.includes(this.filter) : '') ||
                            (this.columns_disaster ? item.disaster.includes(this.filter) : '') ||
                            (this.columns_organize_name ? item.organize_name.includes(this.filter) : '') ||
                            (this.columns_evacuation_location ? item.evacuation_location.includes(this.filter) : '') ||
                            (this.columns_evacuation_entry ? item.evacuation_entry.includes(this.filter) : '') ||
                            (this.columns_evacuation_exit ? item.evacuation_exit.includes(this.filter) : '') ||
                            (this.columns_evacuation_area ? item.evacuation_area.includes(this.filter) : '') ||
                            (this.columns_evacuation_capacity ? item.evacuation_capacity.includes(this.filter) : '') ||
                            (this.columns_evacuation_latitude ? item.evacuation_lat.includes(this.filter) : '') ||
                            (this.columns_evacuation_longitude ? item.evacuation_lon.includes(this.filter) : '') ||
                            (this.columns_evacuation_contact_name ? item.evacuation_contact_name.includes(this.filter) : '') ||
                            (this.columns_evacuation_contact_phone ? item.text_tel_detail.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    for (let i = 0; i < this.evacuation_Table.length; i++) {
                        this.evacuation_Table[i]['index'] = i + 1;
                    }
                } else {
                    this.evacuation_Table = [...this.cloneTable];
                    for (let i = 0; i < this.evacuation_Table.length; i++) {
                        this.evacuation_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ
        onFileChange(e) {
            document.getElementById('organize_uploadImageFile').click();

            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    // let imgSize = e.target.files[0];
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //     type: "warning",
                    //     title: "ขนาดไฟล์ใหญ่เกินไป",
                    //     text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //     timer: 3000,
                    //     confirmButtonColor: "#28B463",
                    //   });
                    //   this.clearImage();
                    // } else {
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);
                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                // var MAX_WIDTH = 800;
                                // var MAX_HEIGHT = 800;
                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('io_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('organize_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';
        },
        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            // Doe : เพิ่ม ลำดับ 3/4 จบ
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].disaster == null || data[index].disaster == 'null' || data[index].disaster == '') {
                    data[index].disaster = '-';
                }
                if (data[index].evacuation_lat == null || data[index].evacuation_lat == 'null' || data[index].evacuation_lat == '') {
                    data[index].evacuation_latn = '-';
                }
                if (data[index].evacuation_lon == null || data[index].evacuation_lon == 'null' || data[index].evacuation_lon == '') {
                    data[index].evacuation_lon = '-';
                }
                if (data[index].evacuation_location == null || data[index].evacuation_location == 'null' || data[index].evacuation_location == '') {
                    data[index].evacuation_location = '-';
                }
                if (data[index].evacuation_lat) {
                    data[index].evacuation_lat = parseFloat(data[index].evacuation_lat).toFixed(6);
                }
                if (data[index].evacuation_lon) {
                    data[index].evacuation_lon = parseFloat(data[index].evacuation_lon).toFixed(6);
                }
                if (
                    data[index].evacuation_contact_name == null ||
                    data[index].evacuation_contact_name == 'null' ||
                    data[index].evacuation_contact_name == ''
                ) {
                    data[index].evacuation_contact_name = '-';
                }
                if (
                    data[index].evacuation_contact_phone == null ||
                    data[index].evacuation_contact_phone == 'null' ||
                    data[index].evacuation_contact_phone == ''
                ) {
                    data[index].evacuation_contact_phone = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.evacuationModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        someHandler(message) {
            if (message == 'ch-province') {
                this.iie_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.iie_selectedTambon = null;
            }
        },

        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.evacuationModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            } else {
                this.iie_selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.organize_name
                };
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            organize_name: variable[i].organize_name
                        });
                    }
                }
            }
        },

        async searchEvacuation() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            // console.log('this.selectedOrganize', (JSON.stringify(this.selectedOrganize)));
            var userSelectedOrganize = JSON.stringify(this.selectedOrganize);
            if (userSelectedOrganize != '{}') {
                // console.log('userSelectedOrganize != {} ', (JSON.parse(userSelectedOrganize)).id);
                userSelectedOrganize = JSON.parse(userSelectedOrganize).id;
            } else {
                // console.log('userSelectedOrganize ', userSelectedOrganize);
                userSelectedOrganize = this.selectedOrganize;
            }

            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

            const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
            // console.log("this.organize_table",this.organize_table)
            await this.axios
                .post(`${this.$url_service}/initial/evacuation`, {
                    body: {
                        topic: 'search-table',
                        name: this.location_name,
                        disaster: this.disasterSelect,
                        // organize: this.checkPermission() ? this.selectedOrganize : this.getUserOrganize(),
                        province: this.selectedProvince,
                        amphur: this.selectedAmphur,
                        tambon: this.selectedTambon,
                        organize: this.organize_table, // เช็คหน่วยงานหลัก
                        userOrg,
                        isDistrict
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.evacuation_Table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6

                    for (let i = 0; i < this.evacuation_Table.length; i++) {
                        this.evacuation_Table[i]['index'] = i + 1;
                    }
                    // Doe เพิ่ม สาธารณภัยที่รองรับ
                    let disaster = response.data.data.map((obj) => (disaster = obj.disaster_id));

                    for (let index = 0; index < disaster.length; index++) {
                        const element = disaster[index];
                        // console.log('element ',element);
                        let textAll = '';
                        for (let index = 0; index < JSON.parse(element).length; index++) {
                            const element2 = JSON.parse(element)[index].system_name;
                            // console.log("element2",element2)
                            textAll += `${element2}\n`;
                        }

                        response.data.data[index]['disaster'] = textAll;
                    }
                    // Doe เพิ่ม สาธารณภัยที่รองรับ จบ

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.evacuation_Table);

                    // Doe ค้นหา  5/5 จบ

                    this.evacuation_Table = response.data.data;
                    for (let i = 0; i < this.evacuation_Table.length; i++) {
                        this.evacuation_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.evacuation_Table == id  ",this.evacuation_Table)

                    // this.search()

                    this.setSearchText_Footer();
                });

            this.search();
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.location_name !== '' ||
                this.disasterSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อพื้นที่อพยพ' && this.location_name !== '') {
                        element.textShow = this.location_name;
                    }
                    if (element.DataName === 'สาธารณภัยที่รองรับ' && this.disasterSelect !== null) {
                        element.textShow = this.disasterSelect.system_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }

                    this.text_Footer = true;
                }
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.organize_name !== undefined) {
                    text += element.organize_name + ',';
                }
            }
            return text.slice(0, -1);
        },
        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.iie_lat = variable.lat;
            this.iie_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.iie_lat",this.iie_lat)
            // console.log("this.iie_lon",this.iie_lon)
            if (this.iie_lat !== null && this.iie_lon !== null && this.iie_lat !== '' && this.iie_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.iie_lat !== '' && this.iie_lat !== null && this.iie_lon !== '' && this.iie_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.iie_lat}/lon=${this.iie_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.iie_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.iie_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.iie_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.iie_selectedProvince = null;
                                this.iie_selectedAmphur = null;
                                this.iie_selectedTambon = null;
                            }

                            // console.log("this.iie_selectedProvince",this.iie_selectedProvince)
                            // console.log("this.iie_selectedAmphur",this.iie_selectedAmphur)
                            // console.log("this.iie_selectedTambon",this.iie_selectedTambon)
                        } else {
                            this.iie_selectedProvince = null;
                            this.iie_selectedAmphur = null;
                            this.iie_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.iie_selectedProvince = null;
                this.iie_selectedAmphur = null;
                this.iie_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.iie_selectedProvince",this.iie_selectedProvince)
            //   console.log("this.iie_selectedAmphur",this.iie_selectedAmphur)
            //   console.log("this.iie_selectedTambon",this.iie_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.iie_selectedProvince) {
                this.sP.push(this.iie_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.iie_selectedAmphur) {
                this.sA.push(this.iie_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.iie_selectedProvince == null) {
                this.iie_lat = '';
                this.iie_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.iie_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.iie_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.iie_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.iie_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.iie_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.iie_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.iie_lat = lat;
                        this.iie_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.iie_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.iie_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.iie_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.iie_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.iie_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.iie_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.iie_lat = lat;
                            this.iie_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.iie_lat = '';
                    this.iie_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (this.deleteTable == 'disaster' || this.deleteTable == 'organize') {
                if (this.deleteTable == 'disaster') {
                    this.disaster_table = this.disaster_table.filter((val) => val !== this.disasterTable);
                    this.displayConfirmation = false;
                    this.iie_selectedDisaster = this.disaster_table;
                }
                if (this.deleteTable == 'organize') {
                    this.displayConfirmation = false;
                    this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
                }
            } else {
                const userId = this.getUsername();
                this.displayConfirmation = false;
                // console.log(`Delete ${this.temp} finish!`);
                await this.axios
                    .post(`${this.$url_service}/initial/evacuation?user=${userId}`, {
                        body: {
                            topic: 'delete-evacuation',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchEvacuation()
                    );
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลพื้นที่อพยพ",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลพื้นที่อพยพ',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            //Check null value
            this.iev_phone = [
                {
                    phone: this.contact_phone == '' ? '-' : this.contact_phone,
                    tel: this.contact_phone_office == '' ? '-' : this.contact_phone_office,
                    tel_ext: this.contact_phone_office_ext == '' ? '-' : this.contact_phone_office_ext
                }
            ];
            if (this.iie_location_name == '' || this.iie_selectedOrganize.name == undefined) {
                if (this.iie_location_name == '') {
                    this.error_iie_location_name = true;
                }
                if (this.iie_selectedOrganize.name == undefined) {
                    this.error_iie_organize = true;
                }
            } else {
                if (this.contact_phone) {
                    if (this.contact_phone === '-') {
                        this.error_contact_phone = false;
                    } else if (this.contact_phone.length !== 12) {
                        this.error_contact_phone = true;
                    } else {
                        this.error_contact_phone = false;
                    }
                } else {
                    this.error_contact_phone = false;
                }
                if (this.contact_phone_office) {
                    if (this.contact_phone_office === '-') {
                        this.error_contact_phone_office = false;
                    } else if (this.contact_phone_office.length !== 11) {
                        this.error_contact_phone_office = true;
                    } else {
                        this.error_contact_phone_office = false;
                    }
                } else {
                    this.error_contact_phone_office = false;
                }

                if (!this.error_contact_phone && !this.error_contact_phone_office) {
                    if (this.selectedData == '') {
                        // โหลดเพิ่มแก้ไข 4/8
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 4/8 จบ

                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
                        // const userId = this.decodeJWT.user_id;

                        const userId = this.getUsername();

                        await this.axios
                            .post(`${this.$url_service}/initial/evacuation?user=${userId}`, {
                                body: {
                                    topic: 'add-evacuation',
                                    userOrg,
                                    name: this.iie_location_name,
                                    organize: this.iie_selectedOrganize.id,
                                    location: this.iie_location_detail,
                                    tambon_id: this.iie_selectedTambon,
                                    main_access: this.iie_access_main,
                                    temp_access: this.iie_access_tempolary,
                                    entry: this.iie_entry,
                                    exit: this.iie_exit,
                                    area: this.iie_area,
                                    capacity: this.iie_capacity,
                                    contact_name: this.iie_contact_name,
                                    contact_phone: this.iie_contact_phone,
                                    tel_detail: this.iev_phone,
                                    lat: this.iie_lat,
                                    lon: this.iie_lon,
                                    detail: this.iie_remark,
                                    data: this.disaster_table,
                                    isDistrict,
                                    image: this.$refs.io_image.innerText == null ? '' : this.$refs.io_image.innerText
                                }
                            })
                            .then((response) => {
                                (this.check_duplicate = response.data.message),
                                    // this.initialData();
                                    this.searchEvacuation();
                                // โหลดเพิ่มแก้ไข 5/8
                                this.loadingCreate = false;
                                // โหลดเพิ่มแก้ไข 5/8 จบ
                                // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                                // console.log("this.check_duplicate ",this.check_duplicate)
                                if (this.check_duplicate == 'duplicate evacuation') {
                                    this.$fire({
                                        type: 'error',
                                        title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                        text: 'มีข้อมูลนี้ในระบบแล้ว',
                                        timer: 3000,
                                        confirmButtonColor: '#d33'
                                    });
                                } else {
                                    this.$fire({
                                        title: 'เพิ่มข้อมูลสำเร็จ',
                                        text: 'ข้อมูลพื้นที่อพยพ',
                                        type: 'success',
                                        timer: 3000,
                                        confirmButtonColor: '#28B463'
                                    });
                                }
                            });

                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.evacuationModal = false;
                    } else {
                        if (this.$refs.io_image.innerText == '') {
                            this.$refs.io_image.innerText = this.url;
                        } else {
                            this.$refs.io_image.innerText = this.$refs.io_image.innerText;
                        }
                        // โหลดเพิ่มแก้ไข 6/8 จบ
                        this.loadingCreate = true;
                        // โหลดเพิ่มแก้ไข 6/8 จบ

                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const isDistrict = this.decodeJWT.organize_id === 'or-000157' ? this.decodeJWT.username : '';
                        // const userId = this.decodeJWT.user_id;

                        const userId = this.getUsername();

                        await this.axios
                            .post(`${this.$url_service}/initial/evacuation?user=${userId}`, {
                                body: {
                                    topic: 'edit-evacuation',
                                    id: this.temp,
                                    name: this.iie_location_name,
                                    organize: this.iie_selectedOrganize.id,
                                    location: this.iie_location_detail,
                                    tambon_id: this.iie_selectedTambon,
                                    main_access: this.iie_access_main,
                                    temp_access: this.iie_access_tempolary,
                                    entry: this.iie_entry,
                                    exit: this.iie_exit,
                                    area: this.iie_area,
                                    capacity: this.iie_capacity,
                                    contact_name: this.iie_contact_name,
                                    contact_phone: this.iie_contact_phone,
                                    tel_detail: this.iev_phone,
                                    lat: this.iie_lat,
                                    lon: this.iie_lon,
                                    detail: this.iie_remark,
                                    data: this.disaster_table,
                                    isDistrict,
                                    image: this.$refs.io_image.innerText == null ? '' : this.$refs.io_image.innerText,
                                    userOrg
                                }
                            })
                            .then(() =>
                                // this.initialData()
                                this.searchEvacuation()
                            );
                        // โหลดเพิ่มแก้ไข 7/8
                        this.loadingCreate = false;
                        // โหลดเพิ่มแก้ไข 7/8 จบ
                        // this.$toast.add({
                        //   severity: "success",
                        //   summary: "แก้ไขข้อมูลสำเร็จ",
                        //   detail: `ข้อมูลพื้นที่อพยพ`,
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'success',
                            title: 'แก้ไขข้อมูลสำเร็จ',
                            text: `ข้อมูลพื้นที่อพยพ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.evacuationModal = false;
                    }
                }
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('iie_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/evacuation`, {
                    body: {
                        topic: 'showone-evacuation',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        (this.iie_location_name = response.data.data.evacuation_name),
                        (this.iie_selectedOrganize = {
                            id: response.data.data.organize_id,
                            name: response.data.data.organize_name
                        }),
                        (this.iie_location_detail = response.data.data.evacuation_location),
                        (this.iie_access_main = response.data.data.evacuation_main_access),
                        (this.iie_access_tempolary = response.data.data.evacuation_temp_access),
                        (this.iie_entry = response.data.data.evacuation_entry),
                        (this.iie_exit = response.data.data.evacuation_exit),
                        (this.iie_area = response.data.data.evacuation_area),
                        (this.iie_capacity = response.data.data.evacuation_capacity),
                        (this.iie_contact_name = response.data.data.evacuation_contact_name),
                        (this.iie_contact_phone = response.data.data.evacuation_contact_phone),
                        (this.iev_phone = JSON.parse(response.data.data.tel_detail));
                    // if (this.iev_phone != null) {
                    for (let index = 0; index < this.iev_phone.length; index++) {
                        const element = this.iev_phone[index];
                        this.contact_phone = element.phone;
                        this.contact_phone_office = element.tel;
                        this.contact_phone_office_ext = element.tel_ext;
                        // console.log("element.tel",element.tel)
                    }
                    // }

                    (this.url = this.pickRecordImageRaw(response.data.data, 'image')),
                        (this.iie_lat =
                            response.data.data.evacuation_lat == 'null' || response.data.data.evacuation_lat == null
                                ? ''
                                : response.data.data.evacuation_lat),
                        (this.iie_lon =
                            response.data.data.evacuation_lon == 'null' || response.data.data.evacuation_lon == null
                                ? ''
                                : response.data.data.evacuation_lon),
                        (this.iie_remark = response.data.data.evacuation_detail),
                        (this.iie_selectedDisaster = JSON.parse(response.data.data.disaster_id)),
                        (this.disaster_table = JSON.parse(response.data.data.disaster_id));

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);

                    // Doe เพิ่มหมุด map V.2 7/9
                    if (this.iie_lat !== '' && this.iie_lat !== null && this.iie_lon !== '' && this.iie_lon !== null) {
                        this.inputMap_latlon();
                    } else {
                        this.inputMap_PAT_latlon();
                    }
                    // Doe เพิ่มหมุด map V.2 7/9  จบ
                    // ,
                    // (console.log('this.disaster_table =',this.disaster_table));
                });
        },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('iie_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.evacuationModal = false;
                this.selectedData = '';
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.iie_location_name = '';
            this.iie_selectedOrganize = {};
            this.iie_location_detail = '';
            this.iie_selectedProvince = null;
            this.iie_access_main = '';
            this.iie_access_tempolary = '';
            this.iie_entry = '';
            this.iie_exit = '';
            this.iie_area = '';
            this.iie_capacity = '';
            this.iie_contact_name = '';
            this.iie_contact_phone = '';
            this.iie_lat = '';
            this.iie_lon = '';
            this.iie_remark = '';
            this.iie_selectedDisaster = null;
            this.error_iie_organize = false;
            this.error_iie_location_name = false;
            this.disaster_table = [];
            this.selectedProvince = null;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';

            this.date_create_form = '';
            this.date_update_form = '';
        },
        async clearSearchField() {
            this.location_name = '';
            this.disasterSelect = null;
            this.selectedOrganize = {};
            this.selectedProvince = null;
            this.organize_table = [];
            this.dropdownClearFilerValue += 1;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.location_name = '';
                this.disasterSelect = null;
                this.selectedOrganize = {};
                this.selectedProvince = null;
                this.organize_table = [];
                this.dropdownClearFilerValue += 1;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(iie_lat, iie_lon) {
            let lat = iie_lat;
            let lon = iie_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
                // console.log("this.PAT=tambon",this.PAT)
            } else if (amphur) {
                this.PAT = amphur;
                // console.log("amphur",amphur)
            } else if (province) {
                this.PAT = province;
                // console.log("province",province)
            } else {
                this.PAT = {};
                // console.log("this.PAT={}",this.PAT)
            }
        },
        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.iie_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.iie_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.iie_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.iie_selectedProvince = null;
                this.iie_selectedAmphur = null;
                this.iie_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.iie_selectedProvince",this.iie_selectedProvince)
            // console.log("this.iie_selectedAmphur",this.iie_selectedAmphur)
            // console.log("this.iie_selectedTambon",this.iie_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    organize_name: { cellWidth: 65 },
                    text_tel_detail: { cellWidth: 85 },

                    date_update_ddmmyy: { cellWidth: 70 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    evacuation_location: { cellWidth: 80 },
                    organize_name: { cellWidth: 100 },
                    text_tel_detail: { cellWidth: 105 }
                };
            } else {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelector.length == 0) {
                this.columns_index = false;
                this.columns_img = false;
                this.columns_evacuation_name = false;
                this.columns_disaster = false;
                this.columns_organize_name = false;
                this.columns_evacuation_location = false;
                this.columns_evacuation_entry = false;
                this.columns_evacuation_exit = false;
                this.columns_evacuation_area = false;
                this.columns_evacuation_capacity = false;

                this.columns_evacuation_latitude = false;
                this.columns_evacuation_longitude = false;
                this.columns_evacuation_contact_name = false;
                this.columns_evacuation_contact_phone = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                this.GetData_ColumnsSearch = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
                }
                let getData = this.GetData_ColumnsSearch;
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'image') {
                        this.columns_img = true;
                    } else if (!getData.includes('image')) {
                        this.columns_img = false;
                    }

                    if (element == 'evacuation_name') {
                        this.columns_evacuation_name = true;
                    } else if (!getData.includes('evacuation_name')) {
                        this.columns_evacuation_name = false;
                    }

                    if (element == 'disaster') {
                        this.columns_disaster = true;
                    } else if (!getData.includes('disaster')) {
                        this.columns_disaster = false;
                    }

                    if (element == 'organize_name') {
                        this.columns_organize_name = true;
                    } else if (!getData.includes('organize_name')) {
                        this.columns_organize_name = false;
                    }

                    if (element == 'evacuation_location') {
                        this.columns_evacuation_location = true;
                    } else if (!getData.includes('evacuation_location')) {
                        this.columns_evacuation_location = false;
                    }
                    if (element == 'evacuation_entry') {
                        this.columns_evacuation_entry = true;
                    } else if (!getData.includes('evacuation_entry')) {
                        this.columns_evacuation_entry = false;
                    }
                    if (element == 'evacuation_exit') {
                        this.columns_evacuation_exit = true;
                    } else if (!getData.includes('evacuation_exit')) {
                        this.columns_evacuation_exit = false;
                    }
                    if (element == 'evacuation_area') {
                        this.columns_evacuation_area = true;
                    } else if (!getData.includes('evacuation_area')) {
                        this.columns_evacuation_area = false;
                    }
                    if (element == 'evacuation_capacity') {
                        this.columns_evacuation_capacity = true;
                    } else if (!getData.includes('evacuation_capacity')) {
                        this.columns_evacuation_capacity = false;
                    }
                    if (element == 'evacuation_lat') {
                        this.columns_evacuation_latitude = true;
                    } else if (!getData.includes('evacuation_lat')) {
                        this.columns_evacuation_latitude = false;
                    }
                    if (element == 'evacuation_lon') {
                        this.columns_evacuation_longitude = true;
                    } else if (!getData.includes('evacuation_lon')) {
                        this.columns_evacuation_longitude = false;
                    }

                    if (element == 'evacuation_contact_name') {
                        this.columns_evacuation_contact_name = true;
                    } else if (!getData.includes('evacuation_contact_name')) {
                        this.columns_evacuation_contact_name = false;
                    }

                    // if (element == "evacuation_contact_phone") {
                    //   this.columns_evacuation_contact_phone = true
                    // } else if(!getData.includes("evacuation_contact_phone")){
                    //   this.columns_evacuation_contact_phone = false
                    // }

                    if (element == 'text_tel_detail') {
                        this.columns_evacuation_contact_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_evacuation_contact_phone = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    },

    computed: {}
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgDia {
    width: 100%;
    display: block;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-multiselect-panel) {
    .p-multiselect-items-wrapper {
        max-height: 150px !important;
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
